<template>
<m-pageframe
    title="Reports"
>
<v-container
    fluid
>
    <v-text-field
        autocomplete="off"
        label="Search"
        prepend-icon="mdi-magnify"
        v-model="full_text"
        v-on:input="update"
    >
        <v-menu
            bottom
            offset-y
            slot="append-outer"
        >
            <template v-slot:activator="{ on }">
                <v-icon
                    v-on="on"
                >
                    mdi-dots-vertical
                </v-icon>
            </template>
    
            <v-list>
                <v-list-item
                    v-on:click="onClickStartReport()"
                >
                    <v-list-item-title>Run Report...</v-list-item-title>
                </v-list-item>
            </v-list>
        </v-menu> 
    </v-text-field>

    <v-data-table
        v-if="results != null"
        :headers="headers"
        :items="results"
        :items-per-page="100"
        class="elevation-1"
        :hide-default-footer="true"
        disable-sort
        :footer-props="{
            disableItemsPerPage: false,
            disablePagination: false,
        }"
    >
    
        <template v-slot:item.start_time_date="{ item }">
            {{$rc.pretty(item.start_time,'date')}}
        </template>

        <template v-slot:item.start_time_time="{ item }">
            {{$rc.pretty(item.start_time,'time')}}
        </template>

        <template v-slot:item.action="{ item }">
            <v-icon
                v-if="item.excel_blob_url != null"
                v-on:click="onClickDownload(item)"
            >
                mdi-download
            </v-icon>
        </template>
    
    </v-data-table>
   
</v-container>
</m-pageframe>
</template>

<script>
const _ = require('lodash');
export default {
    data() {
        return {
            full_text: null,
            results: [],

            headers: [
                { text: 'Date', value: 'start_time_date'},
                { text: 'Time', value: 'start_time_time'},
                { text: 'Run By', value: 'start_employee_label'},
                { text: 'Label', value: 'report_label'},
                { text: 'State', value: 'state'},
                { text: 'Action', value: 'action'},
            ],
        }
    },

    /*
	
	final private Optional<String> excel_blob_url;*/

    mounted () {
        this.doUpdate();
    },
    
    methods: {
        update: _.debounce(function(){
            this.doUpdate();
        }, 751),
        
        doUpdate()
        {
            this.$rc.rest({
                'spinner': false,
                'endpoint': 'LIST: /api/v1/reports',
            
                'params' : {
                        'full_text': this.full_text,
                        'report_type': 'red-chirp-business-intelligence', 
                    },
            
                'on_success': (data) => {
                        this.results = data.results;
                    },
            
                'on_error': 'Unable to list recently run reports',
            });
        },
        

        onClickStartReport() {
            this.$router.push({
                'name': 'admin-start-report',
                'params' : {
                }
            });
        },

        onClickDownload(item)
        {
            window.open(item.excel_blob_url);
        },
    },


}
</script>

<style lang="scss" scoped>
</style>